import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import { usePriceVisible } from '@/components/ui/price';

interface Product {
    id: number;
    title: string;
    slug: string;
    total_sold: number;
    price: string;
}

interface TopProductsCardProps {
    products: Product[];
}

export function TopProductsCard({ products }: TopProductsCardProps) {
    const priceVisible = usePriceVisible();
    const ranked = products.slice(0, 5).map((product, index) => ({
        ...product,
        rank: index + 1,
    }));

    return (
        <Card className="gap-0 rounded-xl border-border/70 py-0 shadow-xs">
            <CardHeader className="flex! flex-col items-start gap-1 px-5 pt-5 pb-3">
                <CardTitle className="text-base font-semibold">
                    Top Selling Products
                </CardTitle>
                <CardDescription className="text-xs">
                    Best performers ranked by units sold.
                </CardDescription>
            </CardHeader>
            <CardContent className="px-5 pb-5">
                <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-5">
                    {ranked.map((product) => (
                        <div
                            key={product.id}
                            className="flex items-center gap-3 rounded-lg border border-border/50 bg-muted/30 p-3 transition-colors hover:bg-muted/50"
                        >
                            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary/10 text-xs font-bold text-primary">
                                {product.rank}
                            </div>
                            <div className="min-w-0 flex-1">
                                <p className="truncate text-sm font-medium text-foreground">{product.title}</p>
                                <div className="mt-0.5 flex items-center gap-2 text-xs">
                                    <span className="text-muted-foreground">
                                        {product.total_sold}
                                        {' '}
                                        sold
                                    </span>
                                    {priceVisible && (
                                        <span className="font-semibold text-success">
                                            $
                                            {product.price}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}
